function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M117 60C117 91.4802 91.4802 117 60 117C28.5198 117 3 91.4802 3 60C3 28.5198 28.5198 3 60 3C91.4802 3 117 28.5198 117 60Z",
  stroke: "white",
  strokeWidth: 6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 28H34H77.3092H79.3092V30V39.8751C88.7623 41.7684 95.8702 49.9111 95.8702 59.6691C95.8702 69.4271 88.7623 77.5699 79.3092 79.4632V90.1981V92.1981H77.3092H34H32V90.1981V30V28ZM75.3092 32V39.4608C75.2394 39.4601 75.1695 39.4598 75.0995 39.4598C71.4071 39.4598 67.9397 40.3972 64.9351 42.0408V42.0397H42.8386V45.4796H60.3097C58.3354 47.4275 56.7645 49.7635 55.729 52.3594H42.8386V55.7993H54.7092C54.4595 57.0518 54.3288 58.3456 54.3288 59.6691C54.3288 60.692 54.4069 61.6971 54.5576 62.6792H42.8386V66.1191H55.4091C56.2949 68.6802 57.6938 71.0118 59.4868 72.9985H42.8386V76.4383H63.5036C66.8152 78.6105 70.8052 79.8785 75.0995 79.8785C75.1695 79.8785 75.2394 79.8781 75.3092 79.8775V88.1981H36V32H75.3092ZM75.0995 75.8785C84.4657 75.8785 91.8702 68.5187 91.8702 59.6691C91.8702 50.8195 84.4657 43.4598 75.0995 43.4598C65.7333 43.4598 58.3288 50.8195 58.3288 59.6691C58.3288 68.5187 65.7333 75.8785 75.0995 75.8785ZM75.5171 66.6209L87.4492 55.0112L83.9624 51.4276L73.7737 61.341L67.5624 55.2975L64.0756 58.8811L72.0303 66.6209L73.7737 68.3171L75.5171 66.6209Z",
  fill: "white"
});

function SvgMainCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainCheck);
export default __webpack_public_path__ + "static/media/mainCheck.bfb18845.svg";
export { ForwardRef as ReactComponent };